import React from 'react';

import style from './index.module.scss';

const KimCustomersSuppliersInfo: React.FC = () => (
  <>
    <h1 className={style.header}>Заказчики + поставщики КИМ</h1>

    <div className={style.description}>
      <div className={style.descriptionItems}>
        <div className={style.descriptionItem}>
          Сервис позволяет с помощью различных фильтров посмотреть сводную информацию по каждому Заказчику касательно
          списка ценовых запросов, регионов и поставщиков в КИМ
        </div>
      </div>
    </div>
  </>
);

export default KimCustomersSuppliersInfo;
